import { SEOHead } from '@/components/feature/SEOHead';
import { Header } from '@/components/feature/Header';
import { Footer } from '@/components/feature/Footer';
import { StickyCall } from '@/components/feature/StickyCall';
import { ScrollToTop } from '@/components/feature/ScrollToTop';
import { DevisForm } from '@/components/feature/DevisForm';
import type { ReactNode } from 'react';

interface PageLayoutProps {
  children: ReactNode;
  seo: {
    title: string;
    description: string;
    keywords?: string;
    canonicalUrl?: string;
    ogImage?: string;
    ogType?: string;
    noindex?: boolean;
  };
  showDevisForm?: boolean;
  devisFormCommune?: string;
}

export function PageLayout({ children, seo, showDevisForm = true, devisFormCommune }: PageLayoutProps) {
  return (
    <>
      <SEOHead {...seo} />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          {children}
          {showDevisForm && <DevisForm defaultCommune={devisFormCommune} />}
        </main>
        <Footer />
        <StickyCall />
      </div>
    </>
  );
}